import { apiAuth, apiResponseType } from ".";

export const getEmployeePositionHistories = (employeeId: number) =>
  apiAuth.get(`employee-position-histories?employee_id=${employeeId}`) as apiResponseType;

export const createEmployeePositionHistory = (data) =>
  apiAuth.post("/employee-position-histories/store", data) as apiResponseType;

export const updateEmployeePositionHistory = (uuid: string, data) =>
  apiAuth.post(`employee-position-histories/${uuid}/update`, data) as apiResponseType;

export const deleteEmployeePositionHistory = (uuid: string) =>
  apiAuth.delete(`employee-position-histories/${uuid}/destroy`) as apiResponseType;
